module.exports = __webpack_public_path__ + "9af6d3f18f54b8427080dcc4700acfb4.woff2";